import { forwardRef, useImperativeHandle } from "react";
import { View } from "react-native";
import { useHandleResidentOtherInformation } from "../../hooks/useHandleResidentOtherInformation";
import { ModifyResidentRef } from "../interfaces";
import { OtherInfoCategoryItem } from "../../organisms/OtherInfoCategoryItem";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";

const ResidentOtherInformationFormTemplate = forwardRef<ModifyResidentRef, {}>(
  (_, ref) => {
    const { control, submitForm, categories, setValue } =
      useHandleResidentOtherInformation();

    useImperativeHandle(
      ref,
      () => ({
        continue: submitForm,
      }),
      [submitForm],
    );

    if (!categories) return <LoadingSpinner />;

    return (
      <View className="flex flex-col gap-8">
        {categories.map((category) => (
          <View key={category.id}>
            <OtherInfoCategoryItem
              category={category}
              control={control}
              setValue={setValue}
            />
          </View>
        ))}
      </View>
    );
  },
);

ResidentOtherInformationFormTemplate.displayName =
  "ResidentOtherInformationFormTemplate";
export { ResidentOtherInformationFormTemplate };
